<script>
import Layout from '@layouts/main'

import TheBanner from './components/TheBanner'
import ViewNull from './components/ViewNull'

import { nlToBr } from '@utils'

export default {
  page() {
    return {
      title: this.merchant.name,
    }
  },
  components: { Layout, TheBanner, ViewNull },
  filters: {
    nlToBr,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showSummary() {
      return (
        this.merchant.phoneNumber ||
        this.merchant.email ||
        this.merchant.address ||
        this.merchant.lineId ||
        this.merchant.description
      )
    },
  },
  methods: {
    formatLineId(text) {
      return text.indexOf('@') !== -1 ? text : `@${text}`
    }
  }
}
</script>

<template>
  <Layout>
    <BaseContainer>
      <TheBanner :merchant="merchant"/>
      <template v-if="showSummary">
        <BaseSection
          v-if="merchant.description"
          :title="$t('global.IBOBEE_ABOUT'/* 店家簡介 */)"
        >
          <BaseSubSection>
            <div
              class="is-text-content has-text-align-justify"
              v-html="$options.filters.nlToBr(merchant.description)"
            >
            </div>
          </BaseSubSection>
        </BaseSection>
        <BaseSection
          v-if="merchant.phoneNumber || merchant.email || merchant.address || merchant.lineId"
          :title="$t('global.IBOBEE_ABOUT_CONTACT'/* 店家聯絡資訊 */)"
        >
          <BaseSubSection>
            <div class="columns is-multiline">
              <div
                v-if="merchant.phoneNumber"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a :href="`tel:${merchant.phoneNumber}`" class="button is-small-circle is-small-circle-white">
                      <BaseIcon name="phone" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_PHONE'/* 聯絡電話 */) }}</h5>
                    <a
                      :href="`tel:${merchant.phoneNumber}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{merchant.phoneNumber}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.email"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a :href="`mailto:${merchant.email}`" class="button is-small-circle is-small-circle-white">
                      <BaseIcon name="envelope" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_EMAIL'/* 聯絡電子信箱 */) }}</h5>
                    <a
                      :href="`mailto:${merchant.email}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{merchant.email}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.address"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${merchant.address}`"
                      class="button is-small-circle is-small-circle-white"
                      target="_blank"
                    >
                      <BaseIcon name="home" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_ADDRESS'/* 地址 */) }}</h5>
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${merchant.address}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                      target="_blank"
                    >{{merchant.address}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.lineId"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a
                      :href="`https://line.me/R/ti/p/${formatLineId(merchant.lineId)}`"
                      class="button is-small-circle  is-small-circle-white disable"
                    >
                      <BaseIcon icon-style="fab" name="line" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_LINE'/* 官方Line帳號 */) }}</h5>
                    <a
                      target="_blank"
                      :href="`https://line.me/R/ti/p/${formatLineId(merchant.lineId)}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{formatLineId(merchant.lineId)}}</a>
                  </div>
                </div>
              </div>
            </div>
          </BaseSubSection>
        </BaseSection>
        <!--<div
          v-if="merchant.phoneNumber || merchant.email || merchant.address || merchant.lineId"
          class="booking-section"
        >
          <div class="level subsection is-small">
            <h4
              class="level-left booking-section__title"
            >
              {{ $t('global.IBOBEE_ABOUT_CONTACT'/* 店家聯絡資訊 */) }}
            </h4>
          </div>
          <div class="subsection">
            <div class="columns is-multiline">
              <div
                v-if="merchant.phoneNumber"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a :href="`tel:${merchant.phoneNumber}`" class="button is-small-circle is-small-circle-white">
                      <BaseIcon name="phone" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_PHONE'/* 聯絡電話 */) }}</h5>
                    <a
                      :href="`tel:${merchant.phoneNumber}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{merchant.phoneNumber}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.email"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a :href="`mailto:${merchant.email}`" class="button is-small-circle is-small-circle-white">
                      <BaseIcon name="envelope" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_EMAIL'/* 聯絡電子信箱 */) }}</h5>
                    <a
                      :href="`mailto:${merchant.email}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{merchant.email}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.address"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${merchant.address}`"
                      class="button is-small-circle is-small-circle-white"
                    >
                      <BaseIcon name="home" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_ADDRESS'/* 地址 */) }}</h5>
                    <a
                      :href="`https://www.google.com/maps/search/?api=1&query=${merchant.address}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                      target="_blank"
                    >{{merchant.address}}</a>
                  </div>
                </div>
              </div>
              <div
                v-if="merchant.lineId"
                :class="$style['summaryItem']"
                class="column is-half is-full-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-2 is-2-mobile">
                    <a
                      :href="`https://line.me/R/ti/p/${formatLineId(merchant.lineId)}`"
                      class="button is-small-circle  is-small-circle-white disable"
                    >
                      <BaseIcon icon-style="fab" name="line" />
                    </a>
                  </div>
                  <div class="column">
                    <h5
                      :class="$style['summaryTitle']"
                      class="is-size-6"
                    >{{ $t('global.MERCHANT_ABOUT_LINE'/* 官方Line帳號 */) }}</h5>
                    <a
                      target="_blank"
                      :href="`https://line.me/R/ti/p/${formatLineId(merchant.lineId)}`"
                      :class="$style['summaryDes']"
                      class="is-size-6 is-link-grey has-text-weight-medium"
                    >{{formatLineId(merchant.lineId)}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </template>
      <ViewNull  v-else/>
    </BaseContainer>
  </Layout>
</template>
<style lang="scss" module>
  .summaryItem {
    margin-bottom: 1rem;
  }
  .summaryTitle {
    margin-bottom: 0.25rem;
    font-size: 16px;
    line-height: 22px;
    color: #707070;
    text-transform: capitalize;
    letter-spacing: 1.06px;
  }
  .summaryDes {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.83;
    color: #575c5c;
    letter-spacing: 1px;
  }
</style>
